import { useQuery } from '@tanstack/react-query';
import { ApiCompanyAndContactsRepository } from 'services/company-and-contacts/ApiCompanyAndContactsRepository';
import { QueryKeys } from 'utils/queryKeys';
import type { CompositeEntityId, CrmContact } from 'services/company-and-contacts/mappers';

const EMPTY_CRM_CONTACTS: CrmContact[] = [];

export const useCrmContactsByCompanyId = ({ companyId, enabled = true }: { companyId?: CompositeEntityId; enabled?: boolean } = {}) => {
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: QueryKeys.getCrmContactsByCompanyId(companyId),
    queryFn: () => ApiCompanyAndContactsRepository.getCrmContactsByCompanyId(companyId as CompositeEntityId),
    enabled: enabled && !!companyId,
  });
  return { contacts: data ?? EMPTY_CRM_CONTACTS, isLoading, isError, refetch };
};
